import { StyleSheet, Platform } from "react-native";
import theme from "../theme";
import { getFontSize, dynamicSize } from "../helpers";

export default StyleSheet.create({
	link: {
		color: theme.colors.orange,
		textDecorationLine: "underline",
	},
	navbarText: {
		color: theme.colors.orange,
		fontSize: getFontSize(17),
		fontFamily: "Avenir-Medium",
		lineHeight: getFontSize(20),
	},
	navbarTitle: {
		color: theme.colors.white,
		fontSize: getFontSize(17),
		fontFamily: "Avenir-Heavy",
		lineHeight: getFontSize(22),
	},
	navbarSubtitle: {
		color: theme.colors.subtitle,
		fontSize: getFontSize(10),
		fontFamily: "Avenir-Heavy",
		lineHeight: getFontSize(22),
	},
	formLabel: {
		color: theme.colors.grey8,
		fontSize: getFontSize(12),
		fontFamily: "Avenir-Heavy",
		lineHeight: getFontSize(14),
	},
	formInput:
		Platform.OS === "web"
			? {
					fontSize: 16,
					lineHeight: 19,
			  }
			: {
					color: theme.colors.orange,
					fontSize: getFontSize(17),
					fontFamily: "Avenir-Heavy",
					lineHeight: getFontSize(24),
			  },
	button: {
		color: theme.colors.white,
		fontSize: getFontSize(17),
		fontFamily: "Avenir-Medium",
		lineHeight: getFontSize(20),
	},
	body: {
		color: theme.colors.white,
		fontSize: getFontSize(17),
		fontFamily: "Avenir-Light",
		lineHeight: getFontSize(20),
	},
	tabBarLabel: {
		fontSize: getFontSize(10),
		fontFamily: "Avenir-Medium",
		margin: 0,
		marginTop: -2,
		marginBottom: 0,
		padding: 0,
	},
	search: {
		fontSize: getFontSize(11),
		fontFamily: "Avenir-Medium",
		lineHeight: getFontSize(15),
	},
	pageTitle: {
		fontSize: getFontSize(24),
		fontFamily: "Avenir-Black",
		lineHeight: getFontSize(32),
		color: theme.colors.white,
	},
	pageSubTitle: {
		fontSize: getFontSize(12),
		lineHeight: getFontSize(16),
		fontFamily: "Avenir-Book",
		color: theme.colors.grey7,
	},
	pageDescription: {
		fontSize: getFontSize(15),
		lineHeight: getFontSize(19),
		fontFamily: "Avenir-Medium",
		color: theme.colors.grey9,
		paddingTop: dynamicSize(10),
		paddingBottom: dynamicSize(10),
		marginBottom: dynamicSize(20),
	},
	listItemTitle: {
		fontSize: getFontSize(16),
		lineHeight: getFontSize(21),
		fontFamily: "Avenir-Black",
		color: theme.colors.white,
	},
	listItemPrice: {
		fontSize: getFontSize(16),
		lineHeight: getFontSize(21),
		fontFamily: "Avenir-Heavy",
		color: theme.colors.orange,
	},
	listItemEventDate: {
		fontSize: getFontSize(14),
		lineHeight: getFontSize(21),
		fontFamily: "Avenir-Book",
		color: theme.colors.orange,
		textDecorationLine: "underline",
	},
	listItemDescription: {
		fontSize: getFontSize(14),
		lineHeight: getFontSize(19),
		fontFamily: "Avenir-Medium",
		color: theme.colors.grey8,
	},
	helpText: {
		fontSize: getFontSize(12),
		color: theme.colors.grey6,
		marginTop: 10,
	},
	listFooter: {
		fontSize: getFontSize(14),
		lineHeight: getFontSize(19),
		fontFamily: "Avenir-Medium",
		color: theme.colors.grey8,
		textAlign: "center",
	},
	pickerButton: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.orange,
		fontSize: getFontSize(15),
		lineHeight: getFontSize(18),
	},
	pickerItem: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.black,
		fontSize: getFontSize(24),
		lineHeight: getFontSize(28),
	},
	appSubBarText: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.grey9,
		fontSize: getFontSize(16),
		lineHeight: getFontSize(22),
	},
	sliderPagination: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.white,
		fontSize: getFontSize(16),
		lineHeight: getFontSize(24),
	},
	pagePrice: {
		fontFamily: "Avenir-Light",
		color: theme.colors.orange,
		fontSize: getFontSize(24),
		lineHeight: getFontSize(32),
		opacity: 0.69,
	},
	divider: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.aluminium,
		fontSize: getFontSize(14),
		lineHeight: getFontSize(16),
	},
	description: {
		fontFamily: "Avenir-Light",
		color: theme.colors.white,
		fontSize: getFontSize(17),
		lineHeight: getFontSize(24),
	},
	sellerName: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.white,
		fontSize: getFontSize(21),
		lineHeight: getFontSize(29),
	},
	sellerPosition: {
		fontFamily: "Avenir-Light",
		color: theme.colors.grey9,
		fontSize: getFontSize(17),
		lineHeight: getFontSize(29),
	},
	contactSubTitle: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.white,
		fontSize: getFontSize(12),
		lineHeight: getFontSize(14),
	},
	contactWindowListItem: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.white,
		fontSize: getFontSize(17),
		lineHeight: getFontSize(20),
		textDecorationLine: "underline",
	},
	askTitle: {
		fontSize: getFontSize(22),
		fontFamily: "Avenir-Black",
		lineHeight: getFontSize(29),
		color: theme.colors.silver,
		marginHorizontal: 30,
		marginBottom: 30,
	},
	askDescription: {
		fontSize: getFontSize(14),
		fontFamily: "Avenir-Black",
		lineHeight: getFontSize(19),
		color: theme.colors.silver,
	},
	orderText: {
		fontSize: getFontSize(14),
		fontFamily: "Avenir-Book",
		lineHeight: getFontSize(16),
		color: theme.colors.grey7,
	},
	appMenuUserName: {
		fontFamily: "Avenir-Book",
		color: theme.colors.white,
		fontSize: getFontSize(23),
		lineHeight: getFontSize(34),
		marginBottom: dynamicSize(5),
	},
	appMenuUserEmail: {
		fontFamily: "Avenir-Book",
		color: theme.colors.menuEmail,
		fontSize: getFontSize(16),
		lineHeight: getFontSize(24),
	},
	appMenuItem: {
		fontFamily: "Avenir-Book",
		color: theme.colors.white,
		fontSize: getFontSize(17),
		lineHeight: getFontSize(23),
	},
	appMenuContact: {
		fontFamily: "Avenir-Book",
		color: theme.colors.menuEmail,
		fontSize: getFontSize(13),
		lineHeight: getFontSize(17),
		marginTop: dynamicSize(12),
	},
	addImageText: {
		fontFamily: "Avenir-Light",
		color: theme.colors.orange,
		fontSize: getFontSize(12),
		lineHeight: getFontSize(15),
	},
	checkboxText: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.white,
		fontSize: getFontSize(16),
		lineHeight: getFontSize(24),
	},
	modalTitle: {
		fontFamily: "Avenir-Medium",
		color: theme.colors.white,
		fontSize: getFontSize(24),
		lineHeight: getFontSize(28),
	},
	groupsDepartmentTitle: {
		color: theme.colors.orange,
		fontSize: getFontSize(15),
		fontFamily: "Avenir-Medium",
		lineHeight: getFontSize(20),
		marginTop: 20,
	},
});
